<template>
  <div>
    <div class=" text-teal-500 font-serif font-hairline text-xl p-5">
      <a class="block" href="/">Home</a>
      <a class="block" href="/creative">Creative Code Lab</a>
      <a class="block" href="/depth-photo">Depth Photo</a>
      <a class="block" href="/audio-visualisation">Audio Visualisation</a>
      <a class="block" href="/jelly">Jelly Fish Studio</a>
      <a class="block" href="/lok">Lok Lok</a>
      <a class="block" href="/bear">Voyage Bear</a>
      <a class="block" href="/bryant-and-jenni-2019">B&J</a>
      <a class="block" href="/words-glowing">Glowing Emoji Matrix</a>
      <a class="block" href="/words">Plain Emoji Matrix</a>
      <a class="block" href="/cascade">Cascading Emoji Pulse</a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
